module.exports = __webpack_public_path__ + "img/family-bread.1cf99b24.png";